/**
 * Utility to hide scrollbars specifically in Microsoft Edge browsers
 */

export function detectEdge(): { isEdge: boolean; isEdgeLegacy: boolean; isEdgeChromium: boolean } {
  if (typeof window === 'undefined') {
    return { isEdge: false, isEdgeLegacy: false, isEdgeChromium: false };
  }

  const userAgent = window.navigator.userAgent;
  
  // Detect Edge Legacy (EdgeHTML)
  const isEdgeLegacy = /Edge\/\d+/.test(userAgent);
  
  // Detect Edge Chromium
  const isEdgeChromium = /Edg\/\d+/.test(userAgent);
  
  const isEdge = isEdgeLegacy || isEdgeChromium;
  
  return { isEdge, isEdgeLegacy, isEdgeChromium };
}

export function hideScrollbarsInEdge(): void {
  const { isEdge, isEdgeLegacy, isEdgeChromium } = detectEdge();
  
  if (!isEdge) {
    return; // Not Edge, don't apply styles
  }
  
  // Create a style element
  const styleElement = document.createElement('style');
  styleElement.id = 'edge-scrollbar-hider';
  
  let cssRules = '';
  
  if (isEdgeLegacy) {
    // Edge Legacy specific rules
    cssRules += `
      * {
        -ms-overflow-style: none !important;
        scrollbar-width: none !important;
      }
    `;
  }
  
  if (isEdgeChromium) {
    // Edge Chromium specific rules
    cssRules += `
      *::-webkit-scrollbar {
        width: 0px !important;
        height: 0px !important;
        display: none !important;
      }
      
      *::-webkit-scrollbar-track {
        display: none !important;
      }
      
      *::-webkit-scrollbar-thumb {
        display: none !important;
      }
      
      *::-webkit-scrollbar-corner {
        display: none !important;
      }
    `;
  }
  
  styleElement.textContent = cssRules;
  
  // Remove existing style if it exists
  const existing = document.getElementById('edge-scrollbar-hider');
  if (existing) {
    existing.remove();
  }
  
  // Add the new style to the document head
  document.head.appendChild(styleElement);
}

export function removeEdgeScrollbarHiding(): void {
  const existing = document.getElementById('edge-scrollbar-hider');
  if (existing) {
    existing.remove();
  }
}
